// downloadData

export const downloadItems = [
  {
    title: "ULFA 2026 General Elections Results",
    type: "pdf",
    fileUrl: "/documents/ulfa-2026-general-elections-results.pdf",
  },
  {
    title: "ULFA Inaugural Ceremony & Fundraising Event",
    type: "pdf",
    fileUrl: "/documents/ulfa-inaugural-ceremony-fundraising-event.pdf",
  },
];